module.exports = __webpack_public_path__ + "img/account.77f657eb.png";